export default function Required() {
  return <span className="text-red-600 ml-0.5">*</span>;
}
